function getTextColor(disabled, highlighted) {
    if (highlighted) {
        return 'primary-darker';
    }
    else if (disabled) {
        return 'dark-muted';
    }
    else
        return 'dark';
}

export { getTextColor as g };

//# sourceMappingURL=getTextColor-1c68221e.js.map